// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\BillingVatResponse

export type BillingVatApiResponse = {
	id: number;
	name: string;
	percentage: number;
};

export type BillingVat = {
	id: number;
	name: string;
	percentage: number;
};

export function hydrateBillingVat(data: BillingVatApiResponse): BillingVat {
	return { ...data };
}